import React, { useState } from "react";
import { Play, X } from "lucide-react";
import ImageWrapper from "@/components/ImageComponent/ImageWrapper";

const VideoTestimonialsSection = ({ data }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  if (!data) return null;
  const { title, subtitle, items, ctaText } = data;

  return (
    <section className="px-6 py-12 bg-[#FEF8F2]">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#8A1C23] mb-3">
            {title}
          </h2>
          <p className="text-gray-600">
            {subtitle}
          </p>
        </div>

        {/* Horizontal Scroll */}
        <div className="overflow-x-auto pb-4">
          <div className="flex gap-4 w-max px-2">
            {items?.map((video) => (
              <div
                key={video.id}
                onClick={() => setSelectedVideo(video)}
                className="w-72 sm:w-80 bg-white rounded-xl shadow-lg cursor-pointer hover:scale-105 transition"
              >
                {/* Thumbnail */}
                <div className="relative h-44 bg-gray-200 overflow-hidden">
                  <ImageWrapper
                    src={video.thumbnail}
                    alt={video.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />

                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <div className="bg-white rounded-full p-4">
                      <Play
                        className="w-8 h-8 text-[#8A1C23]"
                        fill="currentColor"
                      />
                    </div>
                  </div>

                  <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                    {video.duration}
                  </span>
                </div>

                {/* Info */}
                <div className="p-4">
                  <p className="font-semibold text-[#8A1C23]">
                    {video.name}
                  </p>
                  <p className="text-sm text-gray-500">
                    {video.location} • {video.pujaType}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal */}
        {selectedVideo && (
          <div className="fixed inset-0 z-[999] bg-black/80 flex items-center justify-center p-4">
            <div className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden">
              {/* Close */}
              <button
                onClick={() => setSelectedVideo(null)}
                className="absolute top-3 right-3 z-10 bg-black/60 p-2 rounded-full"
              >
                <X className="w-5 h-5 text-white" />
              </button>

              {/* VIDEO FIXED FOR ANDROID */}
              <div className="relative w-full aspect-video bg-black">
                <video
                  key={selectedVideo.videoUrl}
                  src={selectedVideo.videoUrl}
                  poster={selectedVideo.thumbnail}
                  controls
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-contain bg-black"
                />
              </div>

              {/* Info */}
              <div className="bg-white p-4">
                <h3 className="text-lg font-bold text-[#8A1C23]">
                  {selectedVideo.name} – {selectedVideo.pujaType}
                </h3>
                <p className="text-gray-600">{selectedVideo.location}</p>
              </div>
            </div>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-10">
          <button
            onClick={() =>
              document
                .getElementById("booking-form")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="bg-[#8A1C23] text-white px-8 py-3 rounded-md hover:bg-[#6B1419]"
          >
            {ctaText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default VideoTestimonialsSection;
